<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="choice in 5"
            :key="choice"
            :class="['choice', { selected: response != null && response == choice }]">
            {{ choice }}
        </div>
        <div class="radio-range">
            <div v-for="choice in 5" :key="choice">
                <div class="start" v-if="choice == 1">
                    {{ question.start }}
                </div>
                <div class="end" v-if="choice == 5">
                    <i class="el-icon-caret-right"></i>
                    <span>
                        {{ question.end }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {   
    name: 'radio-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Number,
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
